export const environment = {
  remote: true,
  domain: 'dev.lotas-system.info',
  production: true,
};
